module.exports = __webpack_public_path__ + "../../../static/img/bs_ic_06.6fe0fa34.png";